var slugUrl = ":slug([a-z-0-9]+)/:id([0-9]+)/";
var slugUid = ":slug([a-z-0-9]+)/";
export var baseUrl = "/";
export var searchUrl = "".concat(baseUrl, "search/");
export var doorsUrl = "".concat(baseUrl, "doors");
export var allTypesUrl = "".concat(baseUrl, "doors/all-types/");
export var categoryUrl = "".concat(baseUrl, "doors/").concat(slugUrl);
export var collectionUrl = "".concat(baseUrl, "collection/").concat(slugUrl);
export var productUrl = "".concat(baseUrl, "product/").concat(slugUrl);
export var cartUrl = "".concat(baseUrl, "cart/:token?/");
export var checkoutLoginUrl = "".concat(baseUrl, "login/");
export var pageUrl = "".concat(baseUrl, "page/:slug/");
export var guestOrderDetailsUrl = "/order-history/:token/";
export var accountUrl = "".concat(baseUrl, "personal-details/");
export var accountConfirmUrl = "".concat(baseUrl, "account-confirm/");
export var orderHistoryUrl = "".concat(baseUrl, "my-orders/");
export var orderDetailsUrl = "".concat(baseUrl, "my-orders/:token?/");
export var addressBookUrl = "".concat(baseUrl, "billing-&-shipping/");
export var passwordResetUrl = "".concat(baseUrl, "reset-password/");
export var checkoutUrl = "".concat(baseUrl, "checkout/");
export var orderFinalizedUrl = "".concat(baseUrl, "order-finalized/");
export var wishlistUrl = "".concat(baseUrl, "wishlist/");
export var reviewsUrl = "".concat(baseUrl, "reviews");
export var categoryReviewsUrl = "".concat(baseUrl, "reviews/:slug");
export var realizationUrl = "".concat(baseUrl, "inspirations/");
export var projectUrl = "".concat(baseUrl, "inspirations/").concat(slugUid);
export var architectUrl = "".concat(baseUrl, "architect/");
export var contactsUrl = "".concat(baseUrl, "contacts/");
export var blogPostUrl = "".concat(baseUrl, "blog/").concat(slugUid);
export var blogIndexUrl = "".concat(baseUrl, "blog/");
export var prismicPage = "".concat(baseUrl, ":slug/");